import { Tables } from '@/lib/supabase/supabase_types_override';
import { supabase } from '@/lib/supabase/supabaseClient';
import { ValidatedCrmProject } from '../../lib/useValidateCrmProjects';

interface MassImportCrmProjectsWithConfigsParams {
  importedCrmProjects: ValidatedCrmProject[];
  crmId: Tables<'crm'>['id'];
}

export const massImportCrmProjectsWithConfigs = async ({
  importedCrmProjects,
  crmId,
}: MassImportCrmProjectsWithConfigsParams) => {
  let insertedCrmProjects: ((Tables<'crm_project'>['id'] | {id: Tables<'crm_project'>['id']})[] | null) = [];
  try {
    const crmProjectsToInsert = importedCrmProjects.map((crmProject) => {
      const {
        selected_configuration,
        name,
      } = crmProject;
      
      return {
        selected_configuration,
        name,
        crm_id: crmId,
      };
    });

    insertedCrmProjects = await supabase
      .from('crm_project')
      .insert(crmProjectsToInsert)
      .select('id')
      .throwOnError()
      .then((res) => res.data);

    if (!insertedCrmProjects || insertedCrmProjects.length === 0) {
      throw new Error('Failed to insert CRM Projects');
    }

    console.log(`Inserted ${insertedCrmProjects.length} CRM projects`);

    const projectIdMap = new Map(
      insertedCrmProjects.map((project, index) => [
        importedCrmProjects[index].id,
        typeof project === 'number' ? project : project?.id,
      ])
    );

    const allConfigsToInsert = importedCrmProjects.flatMap((crmProject) => {
      const insertedProjectId = projectIdMap.get(crmProject.id);
      
      return crmProject.crm_config.map((crmConfig) => {
        const {
          name,
          selected_configuration
        } = crmConfig;
        
        return {
          name,
          selected_configuration,
          crm_id: crmId,
          crm_project_id: insertedProjectId,
        };
      });
    });

    if (allConfigsToInsert.length > 0) {
      await supabase
        .from('crm_config')
        .insert(allConfigsToInsert)
        .throwOnError();
      
      console.log(`Inserted ${allConfigsToInsert.length} CRM configs`);
    }

  } catch (err) {
    console.error('Error importing CRM Projects with Configs:', err);
    if(insertedCrmProjects && insertedCrmProjects.length > 0)
    await supabase
      .from('crm_project')
      .delete()
      .in('id', insertedCrmProjects.map(project => typeof project === 'number' ? project : project?.id))
      .throwOnError();
    throw err;
  }
};